(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('voucher-sale-confirmation', {
            parent: 'entity',
            url: '/voucher-sale-confirmation?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'vobeApp.voucherSaleConfirmation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmations.html',
                    controller: 'VoucherSaleConfirmationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voucherSaleConfirmation');
                    return $translate.refresh();
                }]
            }
        })
        .state('voucher-sale-confirmation-detail', {
            parent: 'entity',
            url: '/voucher-sale-confirmation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'vobeApp.voucherSaleConfirmation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-detail.html',
                    controller: 'VoucherSaleConfirmationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voucherSaleConfirmation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VoucherSaleConfirmation', function($stateParams, VoucherSaleConfirmation) {
                    return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'voucher-sale-confirmation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('voucher-sale-confirmation-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-dialog.html',
                    controller: 'VoucherSaleConfirmationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoucherSaleConfirmation', function(VoucherSaleConfirmation) {
                            return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voucher-sale-confirmation.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-dialog.html',
                    controller: 'VoucherSaleConfirmationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdAt: null,
                                confirmationUuid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('voucher-sale-confirmation', null, { reload: 'voucher-sale-confirmation' });
                }, function() {
                    $state.go('voucher-sale-confirmation');
                });
            }]
        })
        .state('voucher-sale-confirmation.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-dialog.html',
                    controller: 'VoucherSaleConfirmationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoucherSaleConfirmation', function(VoucherSaleConfirmation) {
                            return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voucher-sale-confirmation', null, { reload: 'voucher-sale-confirmation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voucher-sale-confirmation.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-delete-dialog.html',
                    controller: 'VoucherSaleConfirmationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VoucherSaleConfirmation', function(VoucherSaleConfirmation) {
                            return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voucher-sale-confirmation', null, { reload: 'voucher-sale-confirmation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
